import React from 'react'
import HiltonHonorsLogo from '../../assets/apartment-collection-logo.png'

const HiltonWelcomeBanner = () => (
  <div
    className="bg-teal-50 rounded-lg px-8 py-3 mt-6 mb-6 mx-auto w-4/5 flex items-center gap-4"
    role="banner"
    aria-label="Hilton Honors welcome"
  >
    <img
      src={HiltonHonorsLogo}
      alt="Hilton Honors"
      className="h-10 flex-shrink-0"
    />
    <p className="text-sm text-midnight">
      <strong>
        Welcome! We're glad you booked your stay with Placemakr through Hilton.
      </strong>{' '}
      If you have any questions, reach out anytime at{' '}
      <a href="mailto:hello@placemakr.com" className="underline">
        hello@placemakr.com
      </a>
      .
    </p>
  </div>
)

export default HiltonWelcomeBanner
